import { HttpParams } from '@angular/common/http';
import { GetVatRatesQueryParamsInterface } from '../definitions/get-vat-rates-query-params.interface';

export function createQueryParams(paramsObj: GetVatRatesQueryParamsInterface): HttpParams {
  let params: HttpParams = new HttpParams();

  if (paramsObj.CountryCode != null) {
    params = params.set('countryCode', paramsObj.CountryCode);
  }

  if (paramsObj.EffectiveOn != null) {
    params = params.set('effectiveOn', paramsObj.EffectiveOn);
  }

  return params;
}